// src/App.jsx
import React from 'react';
import Header from './components/Header.jsx';
import HeroSection from './components/HeroSection.jsx';
import SeenOnSection from './components/SeenOnSection.jsx';
import ProblemSection from './components/ProblemSection.jsx';
import BenefitsSection from './components/BenefitsSection.jsx';
import HowItWorksSection from './components/HowItWorksSection.jsx';
import IngredientsSection from './components/IngredientsSection.jsx';
import TestimonialsSection from './components/TestimonialsSection.jsx';
import ComparisonSection from './components/ComparisonSection.jsx';
import FaqSection from './components/FaqSection.jsx';
import CallToActionSection from './components/CallToActionSection.jsx';
import GetYourGruns from './components/GetYourGruns.jsx';
import Join from './components/Join.jsx';
import UsVsThem from './components/UsVsThem.jsx';
import Footer from './components/Footer.jsx';
import './index.css';
import RecommendedByExpert from './components/RecommendedByExpert.jsx';
import LastQuestion from './components/LastQuestion.jsx';
function App() {
    return (
        <div className="min-h-screen flex flex-col">
            <main className="flex-grow">
                <HeroSection />
                <GetYourGruns />    
                <Join />
                <UsVsThem />
                <RecommendedByExpert />
                <LastQuestion />
                {/* <SeenOnSection />
                <ProblemSection />
                <BenefitsSection />
                <HowItWorksSection />
                <IngredientsSection />
                <TestimonialsSection />
                <ComparisonSection />
                <FaqSection />
                <CallToActionSection /> */}
            </main>
        </div>
    );
}

export default App;